import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-checkbox-value-field',
  templateUrl: './checkbox-value-field.component.html',
  styleUrls: ['./checkbox-value-field.component.css']
})
export class CheckboxValueFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() value: any;
  @Input() hideErrors = false;
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/checkbox-value-field/checkbox-value-field.component.ts